<template>
  <page-body>


    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-left:10px; padding-top:10px; padding-bottom:0px;">
      <el-form :inline="true" :model="filters">
        <el-row :gutter="24">
          <el-col :span="20">
            <el-form-item>
              <!-- <el-button type="primary" icon="edit" @click="handleAdd">新增</el-button> -->
              <el-button type="primary" icon="edit" @click="handleAdd">新增</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-input v-model="filters.name" placeholder="用户名称" @keyup.enter="myonkeyup" @change="getUsers"
                        icon="search"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="users" border stripe :search-def='getSearchDef()' highlight-current-row v-loading="listLoading"
              @selection-change="selsChange" @row-dblclick="rowDblclick" style="width: 100%;">
      <el-table-column type="index" width="60">
      </el-table-column>
      <el-table-column prop="commonName" label="用户名称" width="120" sortable>
      </el-table-column>
      <el-table-column prop="username" label="登录名" width="120" sortable>
      </el-table-column>
      <el-table-column prop="role" label="角色" width="120" sortable :formatter="formatter">
      </el-table-column>
      <el-table-column prop="startDate" label="有效期从" width="120" sortable>
      </el-table-column>
      <el-table-column prop="endDate" label="有效期到" width="120" sortable>
      </el-table-column>

      <el-table-column prop="venderName" label="供应商" min-width="150" sortable>
      </el-table-column>
      <el-table-column prop="itemName" label="查询商品名称" min-width="150" sortable>
      </el-table-column>
      <!--  <el-table-column label="可查询商品名称" min-width="150" >
      <template scope="scope" >
          <el-popover trigger="hover" placement="top" v-for="item in scope.row.items" >
            <p>商品编号: {{ item.item.itemNo}}</p >
            <p>规格: {{ item.item.spec}}</p >
            <a slot="reference" class="name-wrapper">
              <el-tag>{{item.item.itemName}}</el-tag>&nbsp;&nbsp;
            </a>
          </el-popover>
        </template>
    </el-table-column> -->
      <el-table-column prop="department" label="部门" sortable>
      </el-table-column>
      <el-table-column prop="subVenderName" label="库位" sortable>
      </el-table-column>
      <el-table-column label="操作" width="250">
        <template scope="scope">
          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <el-button type="primary" size="small" icon="edit" @click="handleEdit(scope.$index, scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="重设密码" placement="top">
            <el-button type="warning" size="small" icon="setting"
                       @click="handleReset(scope.$index, scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <el-button type="danger" size="small" icon="close" @click="handleDel(scope.$index, scope.row)"></el-button>
          </el-tooltip>

        </template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">

      <el-pagination style="float:right;"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="page"
                     :page-sizes="[5, 10, 15, 20]"
                     :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total">
      </el-pagination>
    </el-col>
    <!--新增界面-->
    <el-dialog v-model="addFormVisible" width="70%" top="8%" :show-close=false>
      <div slot="title" class="box-header with-border">
        <h3 class="box-title">新增用户&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h3>
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
      <el-form :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm">
        <el-form-item label="用户名称" prop="commonName" required>
          <el-input v-model="addForm.commonName" style="width: 70%;"></el-input>
        </el-form-item>
        <el-form-item label="登录名" prop="username" required>
          <el-input v-model="addForm.username" style="width: 70%;"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password" required>
          <el-input v-model="addForm.password" style="width: 70%;"></el-input>
        </el-form-item>
        <el-form-item label="有效期从">
          <el-date-picker v-model="startDate" type="date" placeholder="选择日期" style="width: 70%;"></el-date-picker>
        </el-form-item>
        <el-form-item label="有效期到">
          <el-date-picker v-model="endDate" type="date" placeholder="选择日期" style="width: 70%;"></el-date-picker>
        </el-form-item>
        <el-form-item label="角色" required>
          <el-select v-model="addForm.role" filterable="" clearable remote placeholder="请选择" style="width: 70%;">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"
                       :disabled="item.disabled">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="供应商名称">
          <el-select multiple v-model="addForm.venderName" filterable="" clearable remote placeholder="请输入供应商名称"
                     :remote-method="remoteMethod" style="width: 70%;">
            <el-option v-for="item in venders" :key="item.key" :label="item.label" :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称">
          <el-select multiple v-model="addForm.itemName" filterable="" clearable remote placeholder="请输入商品名称"
                     :remote-method="remoteMethod2" style="width: 70%;">
            <el-option v-for="item in items" :key="item.key" :label="item.label" :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门名称">
          <el-select v-model="addForm.department" filterable="" clearable remote placeholder="请输入部门名称"
                     :remote-method="getDepartments" style="width: 70%;">
            <el-option v-for="item in departments" :key="item.key" :label="item.label" :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="业务库位">
          <el-select v-model="addForm.subVenderName" filterable="" multiple clearable remote placeholder="请输入业务库位"
                     :remote-method="getsubVenders" style="width: 70%;">
            <el-option v-for="item in subVenders" :key="item.key" :label="item.label" :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否显示单价金额">
          <el-switch v-model="addForm.showMoney"  on-text="显示" off-text="隐藏"> ></el-switch>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog v-model="editFormVisible" width="70%" top="8%" :show-close=false>
      <div slot="title" class=" box-header with-border">
        <h3 class="box-title">编辑用户</h3>
      </div>
      <el-form :model="editForm" label-width="120px" :rules="editFormRules" ref="editForm">
        <el-form-item label="用户名称" prop="commonName" required>
          <el-input v-model="editForm.commonName" style="width: 70%;"></el-input>
        </el-form-item>
        <el-form-item label="有效期从" prop="startDate">
          <el-date-picker v-model="startDate" type="date" placeholder="选择日期" style="width: 70%;"></el-date-picker>
        </el-form-item>
        <el-form-item label="有效期到" prop="endDate">
          <el-date-picker v-model="endDate" type="date" placeholder="选择日期" style="width: 70%;"></el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="角色" required>
        <el-select v-model="editForm.role" filterable="" clearable remote placeholder="请选择"  style="width: 70%;" >
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" >
                  </el-option>
              </el-select>
        </el-form-item> -->
        <el-form-item label="供应商名称">
          <el-select multiple v-model="editForm.venderName" filterable="" clearable remote placeholder="请输入供应商名称"
                     :remote-method="remoteMethod" style="width: 70%;">
            <el-option v-for="item in venders" :key="item.key" :label="item.label" :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称">
          <el-select multiple v-model="editForm.itemName" filterable="" clearable remote placeholder="请输入商品名称"
                     :remote-method="remoteMethod2" style="width: 70%;">
            <el-option v-for="item in items" :key="item.key" :label="item.label" :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门名称">
          <el-select v-model="editForm.department" filterable="" clearable remote placeholder="请输入部门名称"
                     :remote-method="getDepartments" style="width: 70%;">
            <el-option v-for="item in departments" :key="item.key" :label="item.label" :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="业务库位">
          <el-select v-model="editForm.subVenderName" filterable="" multiple clearable remote placeholder="请输入业务库位"
                     :remote-method="getsubVenders" style="width: 70%;">
            <el-option v-for="item in subVenders" :key="item.key" :label="item.label" :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否显示单价金额">
          <el-switch v-model="editForm.showMoney"  on-text="显示" off-text="隐藏"> ></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>
    <!--重设密码-->
    <el-dialog v-model="resetVisible" width="70%" top="8%" :show-close=false>
      <div slot="title" class=" box-header with-border">
        <h3 class="box-title">重设密码</h3>
      </div>
      <el-form :model="resetForm" label-width="120px" ref="resetForm">
        <el-form-item label="密码" prop="password" required>
          <el-input v-model="resetForm.newPassword" style="width: 70%;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="resetVisible = false">取消</el-button>
        <el-button type="primary" @click.native="resetSubmit">重设</el-button>
      </div>
    </el-dialog>


  </page-body>

</template>

<script>
  //import NProgress from 'nprogress'
  import {webapi} from '../../api/api';
  import util from '../../common/js/util';

  export default {
    data() {
      return {
        disable: true,
        options: [{
          value: 'ROLE_USER',
          label: '用户'
        }, {
          value: 'ROLE_ADMIN',
          label: '操作员',
          disabled: true
          // }, {
          //   value: 'ROLE_LEADER',
          //   label: '领导'
        }],
        filters: {
          name: ''
        },
        startDate: '',
        endDate: '',
        pageSize: 15,
        users: [],
        items: [],
        venders: [],
        departments: [],
        subVenders: [],
        total: 0,
        page: 1,
        listLoading: false,
        sels: [],//列表选中列

        addFormVisible: false,//新增界面是否显示
        addLoading: false,
        addFormRules: {
          commonName: [
            {required: true, message: '请输入用户名称', trigger: 'blur'}
          ],
          username: [
            {required: true, message: '请输入登录名', trigger: 'blur'}
          ],
          password: [
            {required: true, message: '请输入密码', trigger: 'blur'}
          ]
        },
        //新增界面数据
        addForm: {
          commonName: '',
          username: '',
          password: '',
          startDate: '',
          endDate: '',
          role: 'ROLE_USER',
          department: '',
          subVenderName: '',
          showMoney: false,
          venderName: [],
          itemName: []
        },

        editFormVisible: false,//编辑界面是否显示
        editLoading: false,
        editFormRules: {
          commonName: [
            {required: true, message: '请输入用户名称', trigger: 'blur'}
          ]
        },
        //编辑界面数据
        editForm: {
          commonName: '',
          startDate: '',
          endDate: '',
          department: '',
          subVenderName: [],
          showMoney: false,
          venderName: [],
          itemName: []
        },
        resetVisible: false,
        resetForm: {
          newPassword: '',
        }

      }
    },
    methods: {
      formatter: function (row, column) {
        return row.role == "ROLE_USER" ? "用户" : row.role == "ROLE_ADMIN" && row.username != "admin" ? "操作员" : "管理员";
      },
      remoteMethod(query) {
        var vm = this;
        let para = {
          query: query
        };
        webapi.post('/vender/findAll', para)
          .then(function (response) {
            vm.venders = response.data.map(item => {
              return {
                key: item.venderName,
                value: item.venderName,
                label: item.venderName
              };
            });
          }).catch((error) => {
          vm.$message.error(error.response.data['message']);
        });
      },
      remoteMethod2(query) {
        var vm = this;
        let para = {
          query: query
        };
        webapi.post('/item/findAll', para)
          .then(function (response) {
            vm.items = response.data.map(item => {
              return {
                key: item.itemNo,
                value: item.itemNo,
                label: item.itemNo + ' ' + item.itemName
              };
            });
          }).catch((error) => {
          vm.$message.error(error.response.data['message']);
        });
      },
      handleSizeChange(val) {

        this.pageSize = val
        this.getUsers();
        // this.getBranchWarehouse();
      },
      handleCurrentChange(val) {
        this.page = val;
        this.getUsers();
      },
      getSearchDef() {
        return {
          offset: 12,
          placeholder: 'please input searchkey'
          //,
          //props: ['state', 'flow_type'] // can be string or Array
        }
      },
      getDepartments(query) {
        var vm = this;
        let para = {
          query: query
        };
        webapi.post('/department/findAll', para)
          .then(function (response) {
            vm.departments = response.data.map(item => {
              return {
                key: item.departmentName,
                value: item.departmentName,
                label: item.departmentName
              };
            });
          }).catch((error) => {
          vm.$message.error(error.response.data['message']);
        });
      },
      getsubVenders(query) {
        var vm = this;
        let para = {
          query: query
        };
        webapi.post('/subVender/findAll', para)
          .then(function (response) {
            vm.subVenders = response.data.map(item => {
              return {
                key: item.subVenderName,
                value: item.subVenderName,
                label: item.subVenderName
              };
            });
          }).catch((error) => {
          vm.$message.error(error.response.data['message']);
        });
      },
      getUsers() {
        var vm = this;

        let para = {
          params: {
            offset: (vm.page - 1) * vm.pageSize,
            max: vm.pageSize,
            name: vm.filters.name
          }
        };
        vm.listLoading = true;
        //NProgress.start();

        webapi.get('/user', para)
          .then(function (response) {
            vm.total = response.data.total;
            vm.users = response.data.results;
            vm.listLoading = false;
          }).catch((error) => {
          vm.listLoading = false;
          vm.$message.error(error.response.data['message']);
        });
      },
      handleReset: function (index, row) {
        if (row.role != "ROLE_USER" && this.disable) {
          this.$message.error("只能修改用户");
        } else {
          this.resetVisible = true;
          this.resetForm = Object.assign({}, row);
        }
      },
      //显示编辑界面
      handleEdit: function (index, row) {
        // if (row.role != "ROLE_USER" && this.disable) {
        //   this.$message.error("只能修改用户");
        // } else {
        this.remoteMethod('');
        this.remoteMethod2('');
        this.editFormVisible = true;
        Object.assign(this.editForm, row);
        this.editForm.commonName = row.commonName;
        this.startDate = row.startDate;
        this.endDate = row.endDate;
        var venderList = [];
        var venderJSON = JSON.parse(row.venderName);
        if (venderJSON && venderJSON != '') {
          venderJSON.forEach(function (item) {
            venderList.push(item)
          });
        }
        this.editForm.venderName = venderList;
        var itemList = [];
        var itemJSON = JSON.parse(row.itemName);
        if (itemJSON && itemJSON != '') {
          itemJSON.forEach(function (item) {
            itemList.push(item)
          });
        }
        this.editForm.itemName = itemList;
        var subVenderList = [];
        var subVenderJSON = JSON.parse(row.subVenderName);
        if (subVenderJSON && subVenderJSON != '') {
          subVenderJSON.forEach(function (item) {
            subVenderList.push(item)
          });
        }
        this.editForm.subVenderName = subVenderList;
        // }
      },
      //显示新增界面
      handleAdd: function () {
        this.addFormVisible = true;
        this.addForm = {
          commonName: '',
          username: '',
          password: '',
          startDate: '',
          endDate: '',
          role: 'ROLE_USER',
          department: '',
          showMoney: false,
          subVenderName: [],
          venderName: [],
          itemName: []
        };
        this.remoteMethod('');
        this.remoteMethod2('');

      },
      handleItem: function (index, row) {
        this.$router.push({path: '/manage/addItem'});
        this.$router.user = row;
      },
      //删除
      handleDel: function (index, row) {
        if (row.role != "ROLE_USER" && this.disable) {
          this.$message.error("只能修改用户");
        } else {
          this.$confirm('确认删除该记录吗?', '提示', {
            type: 'warning'
          }).then(() => {
            this.listLoading = true;
            //NProgress.start();
            let para = {id: row.id};
            webapi.post('/user/deleteAllUserItem', para).then((res) => {
              webapi.delete('/user/' + para.id).then((res) => {
                this.listLoading = false;
                //NProgress.done();
                this.$message({
                  message: '删除成功',
                  type: 'success'
                });
                this.getUsers();
              });
            });
          });
        }
      },
      //新增
      addSubmit: function () {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.addLoading = true;
              //NProgress.start();
              let para = Object.assign({}, this.addForm);
              if (typeof (this.startDate) == 'object') {
                para.startDate = util.formatDate.format(this.startDate, 'yyyy-MM-dd');
              }
              if (typeof (this.endDate) == 'object') {
                para.endDate = util.formatDate.format(this.endDate, 'yyyy-MM-dd');
              }
              webapi.post('/user', para).then((res) => {
                // addItem(para).then((res) => {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: '提交成功',
                  type: 'success'
                });
                this.$refs['addForm'].resetFields();
                this.addFormVisible = false;
                this.getUsers();
                this.startDate = '';
                this.endDate = '';
              }).catch((error) => {
                this.addLoading = false;
                this.$message.error(error.response.data['message']);
              });
            });
          }
        });
      },
      //编辑
      editSubmit: function () {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.editLoading = true;
              //NProgress.start();
              let para = Object.assign({}, this.editForm);
              if (typeof (this.startDate) == 'object') {
                para.startDate = util.formatDate.format(this.startDate, 'yyyy-MM-dd');
              }
              if (typeof (this.endDate) == 'object') {
                para.endDate = util.formatDate.format(this.endDate, 'yyyy-MM-dd');
              }
              // webapi.post('/user/deleteAllUserItem',para).then((res) => {
              webapi.put('/user/' + para.id, para).then((res) => {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: '提交成功',
                  type: 'success'
                });
                this.$refs['editForm'].resetFields();
                this.editFormVisible = false;
                this.getUsers();
                this.startDate = '';
                this.endDate = '';
              });
              // });
            });
          }
        });
      },
      resetSubmit: function () {

        this.$confirm('确认重置吗？', '提示', {}).then(() => {
          //NProgress.start();
          let para = Object.assign({}, this.resetForm);
          webapi.post('/user/reset', para).then((res) => {
            //NProgress.done();
            this.$message({
              message: '重置成功',
              type: 'success'
            });
            this.$refs['resetForm'].resetFields();
            this.resetVisible = false;
            this.getUsers();
          });
        });

      },
      selsChange: function (sels) {
        this.sels = sels;
      },
      rowDblclick: function (row, event) {
      }
    },
    mounted() {
      this.$nextTick(function () {
        this.getUsers();
        this.getDepartments('');
        this.getsubVenders('');
        var username = window.localStorage.getItem('user');
        if (username == "admin") {
          this.disable = false
          this.options[1].disabled = false
        }
      })
    }
  }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// UserTable.vue?00f8ae68